// ---- Business config (EDIT THESE) ----
export const BUSINESS_NAME = "CJB Clean";
export const SLOGAN = "Healthy Spaces. Smarter Solutions. Reliable Service.";

export const CONTACT = {
  phone: "(703) 249-9327",
  phoneHref: "tel:+17032499327",
  email: "hello@cjbclean.com",
  address: "",
  area: "Serves Northern VA, DC & Maryland",
  hours: [
    { d: "Monday – Friday", h: "7:00 am – 7:00 pm" },
    { d: "Saturday", h: "10:00 am – 5:00 pm" },
    { d: "Sunday", h: "Closed" },
  ],
  hoursShort: "Mon–Fri 7am–7pm · Sat 10am–5pm · Sun closed",
};

// Service-area cities across the DMV. `q` is the Google Maps query used by the
// interactive embed map. First entry is the CJB office / default view.
export const SERVICE_AREAS = [
  { name: "CJB Service Area", q: "Northern Virginia", office: true },
  { name: "Alexandria", q: "Alexandria, VA" },
  { name: "Arlington", q: "Arlington, VA" },
  { name: "McLean", q: "McLean, VA" },
  { name: "Tysons", q: "Tysons, VA" },
  { name: "Falls Church", q: "Falls Church, VA" },
  { name: "Fairfax", q: "Fairfax, VA" },
  { name: "Annandale", q: "Annandale, VA" },
  { name: "Springfield", q: "Springfield, VA" },
  { name: "Vienna", q: "Vienna, VA" },
  { name: "Washington DC", q: "Washington, DC" },
  { name: "Bethesda, MD", q: "Bethesda, MD" },
  { name: "Silver Spring, MD", q: "Silver Spring, MD" },
];

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "Services", to: "/services",
    children: [
      { label: "All Services", to: "/services" },
      { label: "Standard Cleaning", to: "/services/standard-cleaning" },
      { label: "Deep Cleaning", to: "/services/deep-cleaning" },
      { label: "Move-In / Move-Out Cleaning", to: "/services/move-in-move-out-cleaning" },
      { label: "Recurring Cleaning", to: "/services/recurring-cleaning" },
      { label: "Commercial Cleaning", to: "/services/commercial-cleaning" },
    ],
  },
  { label: "Service Areas", to: "/service-areas" },
  { label: "Our Story", to: "/our-story" },
  { label: "Capability Statement", to: "/capability-statement" },
  { label: "Contact", to: "/contact" },
];

export const WHY_CHOOSE = [
  {
    title: "Green Cleaning Is Our Standard",
    desc: "Health-first, eco-friendly products on every job — never an upcharge, never a premium add-on.",
    tag: "No upcharge",
  },
  {
    title: "Book in Minutes",
    desc: "Get an instant quote and book online in a few taps. No phone tag, no waiting for callbacks.",
    tag: "Instant Quote",
  },
  {
    title: "Transparent Service",
    desc: "Know exactly what's included before we arrive. Clear scope, clear pricing, zero surprises.",
    tag: "Know what's included",
  },
  {
    title: "Background-Checked Professionals",
    desc: "Every cleaning professional is background-checked before entering your home or business.",
    tag: "Vetted & trusted",
  },
  {
    title: "The CJB Promise",
    desc: "We take pride in delivering exceptional results on every visit. If we happen to overlook something, let us know within 24 hours and we'll return promptly to make it right — at no additional cost.",
    tag: "Our commitment",
  },
];

export const STEPS = [
  { n: "01", title: "Get an Instant Quote", desc: "Tell us about your space and get transparent pricing in minutes." },
  { n: "02", title: "Book Your Cleaning", desc: "Pick a date and time that works — one-time or recurring." },
  { n: "03", title: "Appointment Confirmation", desc: "Receive a clear confirmation of exactly what's included." },
  { n: "04", title: "We're On Our Way", desc: "Your background-checked professional heads to your space." },
  { n: "05", title: "Certified Green Cleaning", desc: "Green Seal certified cleaning products and a thorough, detailed clean." },
  { n: "06", title: "Review & Rebook", desc: "Love it? Rebook or set up a recurring plan in one tap." },
];

export const VALUES = [
  { n: "01", title: "Health First", desc: "The wellbeing of the people in every space comes before everything else." },
  { n: "02", title: "Integrity", desc: "We do what's right — even when no one is watching." },
  { n: "03", title: "Reliability", desc: "We show up, on time, and deliver consistent results every visit." },
  { n: "04", title: "Respect", desc: "For your home, your business, your time, and your trust." },
  { n: "05", title: "Transparency", desc: "Clear pricing, clear scope, clear communication — always." },
];

export const PROMISE = [
  "Green cleaning is always included",
  "Transparent pricing",
  "Reliable professionals",
  "Clear communication",
  "The CJB Promise",
];

const SHARED_EXCLUSIONS = [
  "Heavy debris or construction waste",
  "Moving heavy furniture or appliances",
  "Washing full walls & ceilings",
  "High-reach areas requiring ladders",
  "Garages (available as an add-on)",
  "Fireplaces & chimneys",
  "Mold or biohazard remediation",
  "Exterior windows",
];

export const HIGH_TOUCH = [
  "Doorknobs & handles", "Light switches", "Faucets & fixtures", "Countertops",
  "Appliance handles", "Remote controls", "Railings & banisters", "Cabinet pulls",
];

export const RESIDENTIAL = [
  {
    slug: "standard-cleaning",
    name: "Standard Cleaning",
    blurb: "Regular upkeep that keeps your home looking its best.",
    included: [
      "Dusting of accessible surfaces",
      "Vacuuming & mopping all floors",
      "Kitchen counters, sink & exterior of appliances",
      "Bathroom sinks, toilets, showers & mirrors",
      "Make beds & replace fresh linens (if left out)",
      "Take out trash & tidy up",
    ],
    addons: ["Inside oven", "Inside fridge", "Inside cabinets & drawers", "Hand-wipe blinds", "Pet hair removal", "Interior windows", "Garage cleaning", "Extra laundry loads", "Dishwasher load", "High-touch surface disinfection"],
    excluded: SHARED_EXCLUSIONS,
  },
  {
    slug: "deep-cleaning",
    name: "Deep Cleaning",
    blurb: "A top-to-bottom detailed reset for homes that need extra attention.",
    included: [
      "Everything in a Standard Clean",
      "Baseboards, door frames & vents",
      "Detailed buildup removal in kitchen & bath",
      "Cabinet fronts & light fixtures",
      "Behind & under reachable furniture",
    ],
    addons: ["Inside oven", "Inside fridge", "Interior windows", "Garage cleaning", "Dishwasher load", "TVs & monitors", "Wall spot cleaning", "High-touch surface disinfection"],
    excluded: SHARED_EXCLUSIONS,
  },
  {
    slug: "move-in-move-out-cleaning",
    name: "Move-In / Move-Out Cleaning",
    blurb: "A spotless, empty home — whether you're moving in or handing over the keys.",
    prepNote: "Please make sure the home is empty and the water, power, and lights are on.",
    included: [
      "Full deep clean of the empty home",
      "Inside cabinets, drawers & closets",
      "Inside fridge & oven",
      "Baseboards, doors, frames & handles",
      "Switch plates & outlet covers",
      "Detailed kitchen & bathroom scrub",
      "Floors detailed throughout",
    ],
    addons: ["Interior windows", "Garage cleaning", "Dishwasher load", "Wall spot cleaning", "Carpet spot treatment", "High-touch surface disinfection"],
    excluded: SHARED_EXCLUSIONS,
  },
  {
    slug: "recurring-cleaning",
    name: "Recurring Cleaning",
    blurb: "Consistent care that fits your schedule.",
    included: [
      "Consistent standard clean each visit",
      "Same trusted team where possible",
      "Priority scheduling",
      "Flexible weekly / biweekly / monthly cadence",
      "Best-value recurring rates",
    ],
    addons: ["Inside fridge", "Interior windows", "Extra laundry loads", "Dishwasher load", "High-touch surface disinfection"],
    excluded: SHARED_EXCLUSIONS,
  },
];

export const SPECIALTY = [
  { name: "Post-Construction Cleaning", desc: "Detailed cleanup after renovations or new builds — dust, debris removal & fine finishing." },
  { name: "Airbnb & Vacation Rental Turnovers", desc: "Fast, reliable turnovers that keep your listing guest-ready and five-star clean." },
  { name: "Event Cleaning", desc: "Before-and-after cleaning for gatherings, parties & special occasions." },
];

export const COMMERCIAL_CATEGORIES = [
  { category: "Professional Offices", items: ["Offices", "Small Businesses"] },
  { category: "Multi-Family & Property Management", items: ["Property Management & Multi-Family Housing", "Apartment Community Common Areas", "HOA & Condo Association Common Areas", "Student Housing"] },
  { category: "Community Facilities", items: ["Churches & Places of Worship", "Senior Living Facilities"] },
  { category: "Retail", items: ["Retail Stores"] },
];

export const COMMERCIAL_SERVICES = [
  "General Office Cleaning",
  "Common Area & Lobby Cleaning",
  "Restroom Sanitation & Restocking",
  "Floor Care — vacuum, mop & buff",
  "Trash Removal & Recycling",
  "Kitchen & Breakroom Cleaning",
  "Interior Window & Glass Cleaning",
  "Disinfection Services (upon request)",
];

// ---- Instant Quote pricing (real CJB Clean rates) ----
// House / townhouse / condo / apartment are all the same price. Minimum visit $150.
// Frequency (recurring) discounts apply to STANDARD cleans only — deep & move-in/out
// are flat regardless of frequency. Displayed price is a range: listed price → ~10% higher.
export const PRICE_TABLE = [
  { maxSqft: 800,   label: "Under 800 sq ft",     incBed: 1, incBath: 1, standard: { "One-time": 175, Weekly: 150, Biweekly: 150, Monthly: 160 }, deep: 270, moveout: 305 },
  { maxSqft: 1500,  label: "800–1,500 sq ft",     incBed: 2, incBath: 2, standard: { "One-time": 225, Weekly: 180, Biweekly: 190, Monthly: 205 }, deep: 350, moveout: 390 },
  { maxSqft: 2500,  label: "1,500–2,500 sq ft",   incBed: 3, incBath: 2, standard: { "One-time": 275, Weekly: 220, Biweekly: 235, Monthly: 250 }, deep: 425, moveout: 475 },
  { maxSqft: 3500,  label: "2,500–3,500 sq ft",   incBed: 4, incBath: 3, standard: { "One-time": 345, Weekly: 275, Biweekly: 295, Monthly: 310 }, deep: 535, moveout: 595 },
  { maxSqft: 99999, label: "3,500+ sq ft",        incBed: 5, incBath: 4, standard: { "One-time": 425, Weekly: 340, Biweekly: 360, Monthly: 385 }, deep: 660, moveout: 735, startingAt: true },
];

export const MIN_VISIT = 150;

// Extra rooms beyond what's included in the bucket.
export const EXTRA = {
  standard: { bed: 20, bath: 30 },
  deep: { bed: 30, bath: 45 },   // also applies to move-in/out
};

export const ADDONS = [
  { key: "oven", label: "Inside oven", price: 40, unit: "" },
  { key: "fridge", label: "Inside fridge", price: 40, unit: "" },
  { key: "cabinets", label: "Inside cabinets", price: 60, unit: "" },
  { key: "pethair", label: "Heavy pet hair", price: 25, unit: "" },
  { key: "hightouch", label: "High-touch surface disinfection", price: 25, unit: "" },
  { key: "dishwasher", label: "Dishwasher load (we load & start one load)", price: 10, unit: "" },
  { key: "garage", label: "Garage cleaning", price: 50, unit: "", note: "1-car $50 · 2-car $75 · 3-car $100 · very cluttered confirmed after photos" },
  { key: "laundry", label: "Extra laundry load", price: 30, unit: "per load" },
  { key: "windows", label: "Interior windows (whole home)", price: 6, unit: "each" },
  { key: "blinds", label: "Blinds", price: 8, unit: "per set" },
];

export const FIRST_CLEAN_OFFER = "A welcome gift: your first recurring clean includes a $40 credit.";

export const RECURRING_PROMISE = {
  title: "The CJB Recurring Promise",
  intro: "Included with every weekly, biweekly, and monthly clean:",
  items: [
    "One load of laundry, washed, dried, and folded*",
    "We'll load and start your dishwasher (one load)",
    "A bonus task every visit, like windows in one room, baseboards, inside the microwave, or a fridge wipe-out",
    "Glass doors and mirrors cleaned every visit",
    "The same trusted team, every time we can",
    "An \u201con our way\u201d text and a photo report after each clean",
    "Our 24-hour redo guarantee**",
    "Your price locked for 12 months***",
    "$25 off for you and a friend when you refer someone****",
  ],
  fineprint: [
    "*One load of laundry per visit, using your detergent. Items must be machine washable. No delicates or dry-clean-only items.",
    "**Tell us within 24 hours of your clean, and we'll come back to re-clean the area at no cost.",
    "***Your recurring plan price stays the same for 12 months from your start date.",
    "****Credit is applied after your friend's first paid recurring clean.",
  ],
};

// Full pricing config (bundled default). The admin can override this at runtime
// via GET/PUT /api/pricing; the live values are provided through PricingProvider.
export const DEFAULT_PRICING = {
  price_table: PRICE_TABLE,
  min_visit: MIN_VISIT,
  extra: EXTRA,
  addons: ADDONS,
  first_clean_offer: FIRST_CLEAN_OFFER,
  recurring_promise: RECURRING_PROMISE,
};

const RECURRING = ["Weekly", "Biweekly", "Monthly"];
export const isRecurring = (frequency) => RECURRING.includes(frequency);

export function estimatePrice({ bedrooms, bathrooms, sqft, cleaningType, frequency, addonsTotal = 0 }, pricing = DEFAULT_PRICING) {
  const table = pricing?.price_table || PRICE_TABLE;
  const minVisit = pricing?.min_visit ?? MIN_VISIT;
  const extraRates = pricing?.extra || EXTRA;
  const row = table.find((r) => sqft <= r.maxSqft) || table[table.length - 1];
  const xBed = Math.max(0, (bedrooms ?? 0) - row.incBed);
  const xBath = Math.max(0, (bathrooms ?? 0) - row.incBath);

  let base, extra;
  if (cleaningType === "Deep Cleaning") {
    base = row.deep;
    extra = xBed * extraRates.deep.bed + xBath * extraRates.deep.bath;
  } else if (cleaningType === "Move-In / Move-Out") {
    base = row.moveout;
    extra = xBed * extraRates.deep.bed + xBath * extraRates.deep.bath;
  } else {
    base = row.standard[frequency] ?? row.standard["One-time"];
    extra = xBed * extraRates.standard.bed + xBath * extraRates.standard.bath;
  }

  let price = Math.max(minVisit, base + extra) + addonsTotal;
  const low = price;
  const high = Math.ceil((price * 1.1) / 5) * 5;
  return {
    low,
    high,
    startingAt: !!row.startingAt,
    note: row.startingAt ? "Starting price — final quote confirmed after photos or a video walk-through." : "",
    bucketLabel: row.label,
  };
}

export const IMAGES = {
  founder: "/assets/founder.jpg",
  hero: "https://images.unsplash.com/photo-1631510390389-c1e4fb20ff31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxicmlnaHQlMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwcGxhbnRzJTIwc3VubGlnaHR8ZW58MHx8fHwxNzg0MzIyNjc0fDA&ixlib=rb-4.1.0&q=85",
  residential: "https://images.unsplash.com/photo-1556020685-ae41abfc9365?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwY2xlYW4lMjBiZWRyb29tJTIwaW50ZXJpb3IlMjBkYXlsaWdodHxlbnwwfHx8fDE3ODQzMjI2NzR8MA&ixlib=rb-4.1.0&q=85",
  green: "/assets/green-living-space.jpg",
  commercial: "https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjbGVhbiUyMG9mZmljZSUyMGludGVyaW9yJTIwd29ya3NwYWNlfGVufDB8fHx8MTc4NDMyMjY3NHww&ixlib=rb-4.1.0&q=85",
  lobby: "https://images.unsplash.com/photo-1758448721162-0c77cf477d6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBidWlsZGluZyUyMGxvYmJ5JTIwaW50ZXJpb3IlMjBjbGVhbnxlbnwwfHx8fDE3ODQzMjI2NzR8MA&ixlib=rb-4.1.0&q=85",
  calm: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwcGxhbnRzJTIwc3VubGlnaHR8ZW58MHx8fHwxNzg0MzIyNjc0fDA&ixlib=rb-4.1.0&q=85",
};

export const LOGO = "/assets/cjb-logo.png?v=4";
